import { useEffect, useRef, useState } from 'react';

export const useInViewOnce = (options?: IntersectionObserverInit) => {
  const [isInView, setIsInView] = useState(false);
  const [hasBeenInView, setHasBeenInView] = useState(false);
  const ref = useRef<HTMLElement>(null);

  useEffect(() => {
    const element = ref.current;
    if (!element || hasBeenInView) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasBeenInView) {
          setIsInView(true);
          setHasBeenInView(true);
        }
      },
      {
        threshold: 0.1,
        rootMargin: '50px 0px 50px 0px',
        ...options,
      }
    );

    observer.observe(element);

    return () => {
      observer.unobserve(element);
    };
  }, [hasBeenInView, options]);

  return { ref, isInView, hasBeenInView };
};
